import { Component, Prop, Vue } from "vue-property-decorator";
import { Dropdown, Menu, Icon } from "ant-design-vue";
import { fmtMsg } from "commonui";
import { CommonLocale } from "@/locales/localeid";

enum ContentExposureItemActionEnum {
	MoveUp,
	MoveDown,
	Remove
}

export interface ContentExposureActionProps {
	showMoveUp?: boolean;
	showMoveDown?: boolean;
	isMenuStyle?: boolean;
	onMoveUping?: () => void;
	onMoveDowning?: () => void;
	onRemoving?: () => void;
}

@Component({
	components: {
		Dropdown,
		Menu,
		MenuItem: Menu.Item,
		Icon
	}
})
export default class ContentExposureItemAction extends Vue {
	@Prop({ default: true }) showMoveUp!: boolean;
	@Prop({ default: true }) showMoveDown!: boolean;
	@Prop({ default: true }) isMenuStyle!: boolean;
	@Prop({ default: () => {} }) onMoveUping!: () => void;
	@Prop({ default: () => {} }) onMoveDowning!: () => void;
	@Prop({ default: () => {} }) onRemoving!: () => void;

	get contentExposureItemActionEnum() {
		return ContentExposureItemActionEnum;
	}
	get commonLocale(): any {
		return CommonLocale;
	}
	onActionChange(e) {
		switch (e.key || e) {
			case ContentExposureItemActionEnum.MoveUp:
				this.onMoveUping();
				break;
			case ContentExposureItemActionEnum.MoveDown:
				this.onMoveDowning();
				break;
			case ContentExposureItemActionEnum.Remove:
				this.onRemoving();
				break;
			default:
				break;
		}
	}
	formatMessage(id: string, params?: any): string {
		return fmtMsg(id, params);
	}
}
